import { useQuery } from "@tanstack/react-query";

import { serviceTemplateService } from "../../services/serviceTemplatesService";
import type { ServiceTemplate } from "../../types";

export const useServiceTemplates = () => {
  return useQuery<ServiceTemplate[]>({
    queryKey: ["service-templates"],
    queryFn: async () => serviceTemplateService.list(),
  });
};
